import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../utilities/LogErrors'
//import { useLanguage } from './../../../../utilities/LanguageContext'

import { SaveResultCourseToShow } from './../../../../utilities/BL/Navigation'


//Agregar multiidioma


// courseName/levelName ya vienen directo en cada evaluación (agregados por backend, ver
// rama "Nombre de Curso en Resultados"), así que el nombre del tile ya no se arma
// cruzando contra session.user.courses.myCourses — eso podía fallar en silencio si el
// curso ya no estaba ahí, dejando el título vacío o con un "nivel 2 diplomado" enganoso.
const Result = ({ session, result }) => {
    //const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const GoToCourseResults = async (_result) => {
        try {
            //Guardar el curso del que se van a mostrar los resultados
            const response = await SaveResultCourseToShow(session, _result.idCourse)

            if (response.success) {
                navigate('/results')
            } else {
                console.log(response.message)
            }
        } catch (error) {
            await LogErrors('GoToCourseResults Result', error)
        }
    }

    const resultName = result?.courseName
        ? `${result.courseName}${result.levelName ? ` nivel ${result.levelName}` : ''}`
        : null

    return (
        <div className='Dashboard--V2__Sections__List__Items--Ztudent Dashboard--V2__Sections__List__Items--Blue' onClick={() => GoToCourseResults(result)}>
            <p className='Dashboard--V2__Sections__List__Items--Ztudent__Subtitle'><i className='bi bi-file-earmark-bar-graph'></i> Resultado</p>
            <p className='Dashboard--V2__Sections__List__Items--Ztudent__Title'>{resultName}</p>

            <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Ztudent__Buttons' onClick={() => GoToCourseResults(result)}>
                <i className='bi bi-arrow-right'></i>
            </button>
        </div>
    )
}

export { Result };
